import Board from './Board/Board';
import Sticky from './Sticky/Sticky';
import Timeline from './Timeline/Timeline';
import Spotlight from './Spotlight/Spotlight';
import Minimal from './Minimal/Minimal';
import Callout from './Callout/Callout';
import Ornament from './Ornament/Ornament';

const templates = {
  Board,
  Sticky,
  Timeline,
  Spotlight,
  Minimal,
  Callout,
  Ornament,
};

export default templates;